module.exports = __webpack_public_path__ + "img/27_32.ab76dd93.png";